// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a3216f87","453":"ccf37b66"}[chunkId] + ".chunk.js";
};